import React from 'react'
import Header from '../Header/Header'
import CurrentPageContainer from './CurrentPageContainer'
import WideMapArea from './WideMapArea'
import Paper from '@material-ui/core/Paper'
import { withStyles } from '@material-ui/core/styles'

const width='460px'

const styles = (theme) => ({
	root: {
		height: '100%',
		display: 'flex',
		flexDirection: 'row',
		overflow: 'hidden'
	},
	sidebar: {
		display: 'flex',
		flexDirection: 'column',
		width: width,
		height: '100%',
		borderRadius: 0,
		zIndex: theme.zIndex.onTopOfMap
	},
	currentpage: {
		display: 'flex',
		flexDirection: 'column',
		overflowY: 'auto',
		height: '100%',
		zIndex: theme.zIndex.onTopOfMap
	}
})

const WideLayout = ({ classes }) => (
	<div className={classes.root}>
		<Paper elevation={24} className={classes.sidebar}>
			<Header />
			<div className={classes.currentpage}>
				<CurrentPageContainer />
			</div>			
		</Paper>
		<WideMapArea />
	</div>
)

export default withStyles(styles)(WideLayout)



// WEBPACK FOOTER //
// ./src/components/Layout/WideLayout.js